//import React, { Component } from "react";
import React, { FC, useState, useEffect } from "react";
import getWeb3 from "./getWeb3";
import Web3 from "web3";
import ThronezContract from "./contracts/Thronez.json";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import ThronezCard from './ThronezCard';

const useStyles = makeStyles(theme => ({
    connectWallet: {
        textAlign: 'center'
    }
}));

const Mint = () => {
    const classes = useStyles();

    const [ web3, setWeb3 ] = useState(null);
    const [ contract, setContract ] = useState(null);
    const [ accounts, setAccounts ] = useState(null);
    const [ tokens, setTokens ] = useState([]);
    const [ ids, setIds] = useState(null);
    const [ debug, setDebug ] = useState(null);

    useEffect(() => {
        init();
    }, );

    const init = async () => {
    }

    const connectWallet = async () => {
        try {
            let web3;
            if (window.ethereum) {
                web3 = new Web3(window.ethereum);
                await window.ethereum.request({ method: "eth_requestAccounts" });
                setWeb3(web3);
            }

            // Use web3 to get the user's accounts.
            const accounts = await web3.eth.getAccounts();
            setAccounts(accounts);

            const networkId = await web3.eth.net.getId();

            // Get the contract instance.
            var contract = null;
            if (137 == networkId) {
                contract = new web3.eth.Contract(ThronezContract.abi, "0x55964812f188E40a3D90fc9e87DEd90C2B1bcc05");
            }
            else if (1 == networkId) {
                window.alert('change network to Polygon');
                contract = new web3.eth.Contract(ThronezContract.abi, "0x773D09EbDC701632BDe57C23B06904c55A33CF23");
            }
            else {
                window.alert('change network to Polygon');
                contract = new web3.eth.Contract(ThronezContract.abi, "0x55964812f188E40a3D90fc9e87DEd90C2B1bcc05");
            }

            if (null != contract) {
                // Set web3, accounts, and contract to the state, and then proceed with an
                // example of interacting with the contract's methods.
                setContract(contract);
            }

            // get THRN tokenNum in wallet.
            const tokenNum = await contract.methods.balanceOf(accounts[0]).call();

            var ids = [];
            var items = [];

            for (var i = 0; i < tokenNum; i++) {
                const id = await contract.methods.tokenOfOwnerByIndex(accounts[0], i).call();
                ids.push(id);
                const tag = await contract.methods.dogtags(id).call();
                items.push({ id:id, tag:tag });
                //items.push(tag);
                //window.alert(tag.accepted);
            }

            setIds(ids);
            setTokens(items);

        } catch (error) {
            // Catch any errors for any of the above operations.
            alert(
                `Failed to load web3, accounts, or contract. ` + error,
            );
            console.error(error);
        }
    };

    const displayThronezCards = () => {
        return tokens.map((tagInfo) => {
            return (
                <ThronezCard info={{ web3: web3, account: accounts[0], contract: contract, tagInfo: tagInfo }} />
            );
        });
    }

    return (
        <div>
            <div className={classes.connectWallet} ><Button variant="outlined" color="primary" onClick={connectWallet}>Connect Wallet</Button></div>
            <div className="main-container">
                <Grid container>
                    {displayThronezCards()}
                </Grid>
            </div>
        </div>
    );
    //}
}

export default Mint;
